import { gql } from 'src/generated/gql';

export const CREATE_PRESCRIPTION_TASK = gql(`
  mutation CreatePrescriptionTask($eventId: ID!, $rnNote: String) {
    staff_createPrescriptionTaskForEvent(eventId: $eventId, rnNote: $rnNote) {
      id
      eventId
      status
    }
  }
`);
